module.exports = __webpack_public_path__ + "banner@2x.a6e46680.png";